import { configuration } from 'mmfintech-checkout-commons'
import { getPaymentMethodImageUrl } from 'mmfintech-commons'

import type { PaymentMethod } from 'mmfintech-checkout-commons/types'

import BankwireImage from '@assets/methods/bank-transfer.png'
import CreditCardImage from '@assets/methods/credit-card.png'
import InstantBankTransferImage from '@assets/methods/instant-bank-transfer.png'
import MobileMoneyImage from '@assets/methods/mobile-money.png'

type PaymentMethodImageProps = {
  method: string
}

export const PaymentMethodImage = ({ method }: PaymentMethodImageProps) => {
  const getImage = () => {
    switch (method as PaymentMethod) {
      case 'EMONEY':
      case 'BANKWIRE':
      case 'LOCAL_BANKWIRE':
        return <img src={BankwireImage} alt='Bank transfer' />

      case 'COMMUNITY_INSTANT_BANK_TRANSFER':
      case 'DIRECT_INSTANT_BANK_TRANSFER':
      case 'INSTANT_BANK_TRANSFER':
        return <img src={InstantBankTransferImage} alt='Instant bank transfer' />

      case 'CREDIT_CARD':
        return <img src={CreditCardImage} alt='Credit card' />

      case 'MOBILE_MONEY':
        return <img src={MobileMoneyImage} alt='Mobile money' />

      default:
        return method ? (
          <img src={`${configuration.readBackendConfig()}${getPaymentMethodImageUrl(method)}`} alt={method} />
        ) : null
    }
  }

  return <span className='image-wrapper'>{getImage()}</span>
}
